import $ from '@vaersaagod/tools/Dom';
import Dispatch from '@vaersaagod/tools/Dispatch';
import * as Events from '../lib/events';

export default el => {
    let isOpen = false;

    const dom = $(el);
    const overlay = $('[data-menu-overlay]');

    const emitClose = () => {
        Dispatch.emit(Events.MENU_CLOSE);
        Dispatch.emit(Events.SCROLL_UNLOCKED);
    };

    const keyup = e => {
        const key = e.keyCode || e.which;
        if (isOpen && key === 27) {
            emitClose();
        }
    };

    const open = () => {
        if (!isOpen) {
            isOpen = true;
            TweenMax.to(el, 0.55, { xPercent: 0, ease: Quint.easeInOut });
            TweenMax.set(overlay.get(0), { display: 'block', opacity: 0 });
            TweenMax.to(overlay.get(0), 0.55, { opacity: 0.8, ease: Quad.easeOut });
            document.addEventListener('keyup', keyup);
        }
    };

    const close = () => {
        if (isOpen) {
            isOpen = false;
            TweenMax.to(el, 0.75, { xPercent: 100, ease: Quint.easeOut });
            TweenMax.to(overlay.get(0), 0.75, { opacity: 0, clearProps: 'all', ease: Quad.easeOut });
            document.removeEventListener('keyup', keyup);
        }
    };

    const init = () => {
        TweenMax.set(el, { display: 'block', xPercent: 100 });
        Dispatch.on(Events.MENU_OPEN, open);
        Dispatch.on(Events.MENU_CLOSE, close);
        overlay.on('click', emitClose);
    };

    const destroy = () => {
        Dispatch.off(Events.MENU_OPEN, open);
        Dispatch.off(Events.MENU_CLOSE, close);
        overlay.off('click');
        TweenMax.killTweensOf(el);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Menu.js